import { useArticlesThemesContext } from '@/creditflowresearch/application/ArticlesAndStats/ArticlesMarketThemesContext';
import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { getRegionsIdFromThemes } from '@/creditflowresearch/ui/components/creditFlow/articles/helpers';
import Region from '@/creditflowresearch/domain/Region';

interface IMarketCellProps {
  row: { themes: string[] },
  useEmDisplayNames?: boolean,
}

const getDisplayName = (regionId: string, useEmDisplayNames: boolean): string | null => {
  const region = Region.from(regionId);
  if (!region) {
    return null;
  }

  if (useEmDisplayNames) {
    return region.getEmDisplayName() || null;
  }

  return region.belongsToMarket()?.getAbbreviation() || null;
};

const MarketCell = ({ row, useEmDisplayNames = false }: IMarketCellProps) => {
  const {
    themes,
    isInitialized: isThemesInitialized,
  } = useArticlesThemesContext();

  if (!isThemesInitialized) {
    return '-';
  }

  const regionIds = getRegionsIdFromThemes(themes, row.themes);

  if (!regionIds.length) {
    return '-';
  }

  const displayNames = [...new Set(
    regionIds.map((id) => getDisplayName(id, useEmDisplayNames)).filter(Boolean),
  )].sort();

  if (!displayNames.length) {
    return '-';
  }

  if (displayNames.length <= 2) {
    return displayNames.join(', ');
  }

  return (
    <Tooltip
      content={ displayNames.join(', ') }
    >
      { displayNames.slice(0, 2)
        .join(', ') }, ...
    </Tooltip>
  );
};

export default MarketCell;
